import { useMutateRequest } from "@ch/api/useMutation";
import {
  type MedicationPassportPartialExcluding_created_coachId_userId_consultId_dependentId_goalActionId_hubVisitId_,
  PrescriptionControllerService,
  type PrescriptionPartialExcluding_id_created_at_medicationPassports_coachId_consultId_userId_dependentId_,
} from "@ch/generated";
import useFirebaseAnalytics from "@ch/helpers/utils/firebase/hooks/useFirebaseAnalytics";
import { FirebaseEventEnum } from "@ch/helpers/utils/firebase/types";
import { NotifySuccess } from "@ch/helpers/utils/helpers";
import { useQueryClient } from "@tanstack/react-query";

const useUpdatePrescriptionPassport = ({
  id,
  payload,
  callback,
}: {
  id?: string;
  payload?:
    | {
        prescription?: PrescriptionPartialExcluding_id_created_at_medicationPassports_coachId_consultId_userId_dependentId_;
        medicationPassports?: MedicationPassportPartialExcluding_created_coachId_userId_consultId_dependentId_goalActionId_hubVisitId_[];
      }
    | undefined;
  callback?: () => void;
}) => {
  const { LogEvent } = useFirebaseAnalytics();
  const queryClient = useQueryClient();
  const { trigger, loading } = useMutateRequest({
    service:
      PrescriptionControllerService.prescriptionControllerUpdateById.bind(
        PrescriptionControllerService,
      ),
    tag: "prescriptionControllerUpdateById",
    payload: {
      id: id ?? "",
      requestBody: payload,
    },
    onSuccess: () => {
      NotifySuccess("Prescription updated successfully!");
      void queryClient.invalidateQueries({
        queryKey: ["usersControllerFetchUserRecentHealthPassport"],
      });
      LogEvent(FirebaseEventEnum.HEALTH_PASSPORT_DELETE, {
        passportType: "prescription",
        extra: {
          id,
        },
      });
      callback?.();
    },
  });

  return {
    updatePrescriptionPassport: trigger,
    loading,
  };
};

export default useUpdatePrescriptionPassport;
